import axios from 'axios';
import download from 'downloadjs';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';

const url = require('url');


const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class BoxService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    const urlObj = url.parse(document.location.href, true);
    // const dev = urlObj.href.indexOf('my.epik.io') !== -1;
    const route = window.location.pathname.split('/');
    // if (!dev) {
    //   return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
    // }
    if (global.myEpik === 'Yes' && route.length === 3) {
      return myEpikBaseURL;
    }
    if (global.myEpik === 'No' && route.length === 3) {
      return unifiedBaseURL();
    }
    global.myEpik = 'Yes';
    return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
  };

  async generateReport({
    cid,
    lid,
    type,
    summary,
    fromDate,
    toDate,
    selectedReport,
    symbol,
    lineTypes,
    alarmProtocolValue,
    integration,
  }) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const REPORT_CONFIG_MAP = new Map([
      ["PAD", { portActivationDetails: { type, includeSummary: summary, from: fromDate, to: toDate }}],
      ["DID", { didAssignmentReport: { type, location: lid }}],
      ["911", { e911EnabledReport: { type, location: lid }}],
      ["TDID", { tempDidReport: { type, location: lid }}],
      ["LT", { 'lineTypeReport': { type, location: lid, from: fromDate, to: toDate }}],
      ["BOL", { 'offlineBoxReport': { type, location: lid, from: fromDate, to: toDate }}],
      ["BAD", { 'bad-ports-report': { type }}],
      ["PAR", { 'portal-assets': { type }}],
      ["DAR", { 'data-center-report': { type }}],
      ["EDI", { 'device-integration-report': { type, integrationType: integration }}],
      ["NSR", { 'network-summary-report': { type }}],
      ["AFR", { 'ata-firmware-report': { type }}],
    ]);
  
    const config = REPORT_CONFIG_MAP.get(symbol) || { 'apr-report': { type, apr: alarmProtocolValue }};
    const [name, params] = Object.entries(config)[0];
  
    const API_URL = `${process.env.REACT_APP_REPORT_URL}/api/reports/${name}`;
  
    const body = symbol === 'LT' ? { cid, lineTypes } : { cid };
  
    const { data } = await axios.post(API_URL, body, {
      params,
      headers,
      responseType: 'blob',
    });

    const reportsWithDate = ['PAD', 'BOL', 'LT'];
    const includeDatesInFilename = reportsWithDate.includes(symbol) ? ` - from ${fromDate} to ${toDate}` : '';
    const fileName = `${selectedReport}${includeDatesInFilename}.${type}`;

    download(data, fileName);
    return data;
  }

  // GET all company group lists
  async getCompanyGroups(pagination, format) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companyGroups?paginateResult=${pagination}&formatResponse=${format}`,
      { headers, timeout: 1000 * 60 * 10 },
    );
    return data;
  }

  // GET all the companies alocated to specific company group
  async getGroupsFilterCompanies(gid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/companyGroups/${gid}`, {
      headers,
    });
    return data;
  }

  async generatePortOrderReport() {
    const API_URL = `${myEpikBaseURL}${apiVersion}/reports/port-orders?type=csv`;
    const data = await axios.post(
      API_URL,
      {},
      {
        headers: { Authorization: `Bearer ${this.api.token}` },
        responseType: 'blob',
      },
    );
    const file = new Blob([data.data], { type: 'text/csv' });
    const fileURL = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = fileURL;
    const fileName = `Port Orders List.csv`;
    a.download = fileName;
    a.click();
  }
}

export default BoxService;
